var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 6.45646C11.1395 6.2734 11.1395 5.9766 10.9565 5.79354C10.7734 5.61049 10.4766 5.61049 10.2935 5.79354L6.25 9.83709L4.70646 8.29354C4.5234 8.11049 4.2266 8.11049 4.04354 8.29354C3.86049 8.4766 3.86049 8.7734 4.04354 8.95646L5.69757 10.6105C6.00267 10.9156 6.49733 10.9156 6.80243 10.6105L10.9565 6.45646Z",
    fill: "#219653"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 8C13.75 11.4518 10.9518 14.25 7.5 14.25C4.04822 14.25 1.25 11.4518 1.25 8C1.25 4.54822 4.04822 1.75 7.5 1.75C10.9518 1.75 13.75 4.54822 13.75 8ZM12.8125 8C12.8125 10.934 10.434 13.3125 7.5 13.3125C4.56599 13.3125 2.1875 10.934 2.1875 8C2.1875 5.06599 4.56599 2.6875 7.5 2.6875C10.434 2.6875 12.8125 5.06599 12.8125 8Z",
    fill: "#219653"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.0e6723f1dc3268b6d67ad371cc900b19.svg";
export { ForwardRef as ReactComponent };